import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { NavLink } from 'react-router';

import styles from './CabinetHeaderNav.module.scss';

export type CabinetHeaderNavItem = {
  to: string;
  label: string;
  Icon: LucideIcon;
  end?: boolean;
  /** Figma 66:2485: непрочитанные - бейдж на пункте, отдельной иконки чата в шапке нет. */
  badge?: ReactNode;
};

export const CabinetHeaderNav = ({
  items,
  className,
}: {
  items: CabinetHeaderNavItem[];
  className?: string;
}) => (
  <nav className={`${styles.nav} ${className ?? ''}`} aria-label='Разделы кабинета'>
    {items.map(({ to, label, Icon, end, badge }) => (
      <NavLink
        key={to}
        to={to}
        end={end}
        title={label}
        className={({ isActive }) => `${styles.item}${isActive ? ` ${styles.active}` : ''}`}
      >
        <Icon size={18} strokeWidth={2} aria-hidden />
        <span className={styles.label}>{label}</span>
        {badge ?? null}
      </NavLink>
    ))}
  </nav>
);
